import React from 'react';
import { Lock } from 'lucide-react';

interface LockedOptionProps {
  message?: string;
  children: React.ReactNode;
}

export default function LockedOption({ message = 'Locked by Organisation', children }: LockedOptionProps) {
  return (
    <div className="relative">
      <div className="opacity-50 pointer-events-none select-none">
        {children}
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="flex items-center gap-2 bg-stone-200 dark:bg-zinc-700 rounded-full px-3 py-1.5 text-xs font-medium text-zinc-500 dark:text-stone-400">
          <Lock className="w-3 h-3" />
          {message}
        </div>
      </div>
    </div>
  );
}
